import { documentApi2, onDocumentBundleSelected2 } from './document-viewer/document-api';
import { Visit } from './domain';

type Bundle = { version: string; createDate?: string };
export type DocumentResolver = {
  openWindow: (visit?: Visit, closeExisting?:boolean) => void;
  openWindowAndValidate: (visit?: Visit) => void;
  onDocumentBundleSelected: (fn: (a: Bundle) => void) => void;
};

let validated = true;
function createDocumentResolver(): DocumentResolver {
  function openWindow(a?: Visit, closeExisting?:boolean) {
    if (validated && a) {
      if(closeExisting){
        documentApi2.closeWindow();
      }
      documentApi2.openWindow(a);
    }
  }

  function onDocumentBundleSelected(fn: (a) => void) {
    onDocumentBundleSelected2(fn);
  }
  function openWindowAndValidate(a?: Visit) {
    validated = false;

    if (a) {
      documentApi2.openWindow(a);
    }

    setTimeout(() => {
      validated = true;
    }, 2000);
  }

  return {
    openWindow,
    openWindowAndValidate,
    onDocumentBundleSelected,
  };
}

export const documentResolver = createDocumentResolver();

export function documentBundleLabel(b: { version: any; createDate: string; worksheetId?: string }): string {
  if (!b?.version) {
    return `Unknown Version`;
  }
  const date = b.createDate ? b.createDate.substring(0, b.createDate.indexOf(' ')) : 'Date Unknown';

  return `v${b.version} ${date} ${b.worksheetId ? ' - ' + b.worksheetId : ''}`;
}
